import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
export class EditVirtualPosInfosApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/virtualPosInfos/edit/',
      requesterInfo,
    })
  }

  public async editVirtualPosInfos(id: number): Promise<any> {
    this.props.url = `${this.props.url}${id}`
    return await this.postAsync<any>()
  }
}
